import { Navigate, useLocation } from "react-router-dom";

const AuthRoute = ({ children }) => {
  const token = localStorage.getItem('dealerModuleToken');
  const location = useLocation();
  const redirectTo = encodeURIComponent(location.pathname + location.search);
  if (token) {
    return children;
  } else {
    return <Navigate to={`/login?redirect=${redirectTo}`} />;
  }
};

export default AuthRoute;
